export default __webpack_public_path__ + "static/media/fourteen.ae4d52e9.jpeg";